import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer fixed ">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Shubhanshu Tiwari</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} <span>  </span> ST</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Shubhanshu9696"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/shubhanshusst10"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiOutlineTwitter />
              </a>
            </li>

            {/* <li className="social-icons">
              <a
                href="linkedin.com/in/shubhanshu-tiwari-4a1025215/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
              </a>
            </li> */}


            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/shubhanshu-tiwari-4a1025215/"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>

            <li className="social-icons"> 
              <a 
                href="https://www.instagram.com/shubhanshu_tiwari__/?next=%2F"
                target="_blank"
                rel="noonpener noreferrer"
              >
                <AiFillInstagram/>
              </a>
            </li>

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
